import React, { Fragment } from "react";
import "../../assets/CSS/publish-model-form.css";
import { useDropzone } from "react-dropzone";
import { isEmpty } from "lodash";
import ImagesHandler from "../../utils/ImagesHandler";
import { useTranslation } from "react-i18next";

const thumbsContainer = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 16,
};

const thumb = {
    display: "inline-flex",
    borderRadius: 2,
    border: "1px solid #eaeaea",
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: "border-box",
};

const thumbInner = {
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
};

const img = {
    display: "block",
    width: "auto",
    height: "100%",
    borderRadius: 0,
};

const DragDropUploadCard = ({
    maxFileNumber,
    fileType,
    files,
    setFiles,
    dimension = "650x350",
}) => {
    const { t } = useTranslation();
    const { getRootProps, getInputProps, isDragAccept, isDragReject } =
        useDropzone({
            maxFiles: maxFileNumber,
            accept: fileType,
            onDrop: async (acceptedFiles) => {
                if (files.length + acceptedFiles.length <= maxFileNumber) {
                    const promiseImages =
                        acceptedFiles &&
                        acceptedFiles.map((acceptedFile) => {
                            return ImagesHandler.formatImageFileBased(
                                acceptedFile,
                                null,
                                650,
                                350
                            );
                        });
                    const base64Images = await Promise.all(promiseImages);
                    setFiles([
                        ...files,
                        ...acceptedFiles.map((file, index) =>
                            Object.assign(file, {
                                preview: base64Images[index],
                            })
                        ),
                    ]);
                }
            },
        });

    const removeThumb = (e, index) => {
        e.stopPropagation();

        setFiles((prevFiles) => {
            return prevFiles.filter((file, innerIndex) => {
                if (innerIndex !== index) {
                    return file;
                }
            });
        });
    };

    const renderThumbs = () => {
        return (
            files &&
            files.map((file, index) => {
                return (
                    <div
                        className="choose-img-wrapper thumb"
                        style={thumb}
                        key={`${file.name}-${index}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={thumbInner}>
                            <img
                                src={file.preview || file.image || file}
                                style={img}
                            />
                        </div>
                        <div
                            onClick={(e) => removeThumb(e, index)}
                            className="absolute right-0"
                        >
                            <i className="fas fa-times-circle btn text-primary-orange" />
                        </div>
                        {/* <div className="choose-img-btn delete-overlay flex">
                            <i className="fas fa-trash-alt"></i>
                            <span className="ml-2 mt-2">
                                <Trans i18nKey="remove">Remove</Trans>
                            </span>
                        </div> */}
                    </div>
                );
            })
        );
    };

    const instructions = [
        {
            condition: fileType,
            content: (
                <>
                    <br />
                    {t("allowedTypes", { fileType: "png, jpg, or jpeg" })}
                </>
            ),
        },
        {
            condition: dimension,
            content: (
                <>
                    <br />
                    {t("preferedDimensions", {
                        dimension,
                    })}
                </>
            ),
        },
        {
            condition: maxFileNumber,
            content: (
                <>
                    <br />
                    {t("maxNumberImages", {
                        maxFileNumber,
                    })}
                </>
            ),
        },
    ];

    const renderInstructions = () => {
        return (
            instructions &&
            instructions.map((instruction, index) => {
                return (
                    <Fragment key={index}>
                        {instruction.condition && instruction.content}
                    </Fragment>
                );
            })
        );
    };

    return (
        <>
            <div className="container">
                <div
                    {...getRootProps({
                        className: `dropzone ${
                            isDragAccept
                                ? "dropzone-active"
                                : isDragReject
                                ? "dropzone-rejects"
                                : ""
                        }`,
                        onClick: (e) =>
                            files.length === maxFileNumber &&
                            e.stopPropagation(),
                    })}
                >
                    <label htmlFor="files" className="dropzone-container m-0">
                        {isEmpty(files) ? (
                            <>
                                <div className="file-icon">+</div>
                                <div className="dropzone-title text-center">
                                    Drag and drop your files or{" "}
                                    <span className="browse">browse</span> your
                                    files
                                    {renderInstructions()}
                                </div>
                            </>
                        ) : (
                            <aside style={thumbsContainer}>
                                {renderThumbs()}
                            </aside>
                        )}
                    </label>
                    {!isEmpty(files) && (
                        <div className="flex justify-center mb-3">
                            {files.length === maxFileNumber ? (
                                <div className="text-dark-gray text-xs">
                                    Max limit of
                                    <span className="text-xs text-primary-color-orange">
                                        {` (${maxFileNumber}) `}
                                    </span>
                                    images reached
                                </div>
                            ) : (
                                <div className="text-dark-gray text-xs">
                                    {t("modelImagesPlaceholders")}
                                    <span className="text-xs text-primary-color-orange">
                                        {` ${maxFileNumber - files.length} `}
                                    </span>
                                    {t("files")}
                                </div>
                            )}
                        </div>
                    )}
                    <input {...getInputProps()} />
                </div>
            </div>
        </>
    );
};
export default DragDropUploadCard;
